import React, { Component } from "react";

import { classNames } from "primereact/utils";
import { PageLayout, StatusBadge } from "../components/ui";
import _ from "lodash";
import { toastService } from "../services/toastService";
import { SortOrderType } from "../models/SearchRequestModel";
import { Column } from "primereact/column";
import { stringFilterMatchModeOptions } from "./Paginator";
import { CurrencyModel } from "../models/CurrencyModel";
import { DataTable } from "primereact/datatable";
import { currenciesApiService } from "../services/api/merchants/CurrenciesApiService";
import { Banknote } from "lucide-react";

interface CurrenciesProps {
    merchantId: number;
}

interface CurrenciesState {
    currencies: CurrencyModel[];
    globalFilterValue: string;
    isLoading: boolean;
}

export default class Currencies extends Component<CurrenciesProps, CurrenciesState> {
    constructor(props: CurrenciesProps) {
        super(props);

        this.state = {
            currencies: [],
            globalFilterValue: "",
            isLoading: false,
        };
    }

    componentDidMount(): void {
        this.loadCurrencies();
    }

    loadCurrencies = async () => {
        this.setState({ isLoading: true });

        const currenciesResult = await currenciesApiService.getMerchantActiveCurrencies(this.props.merchantId);

        this.setState({ isLoading: false });

        if (!currenciesResult.success) {
            toastService.error(currenciesResult.message);
        }

        this.setState({ currencies: currenciesResult.data });
    };

    render() {
        return (
            <PageLayout heading="Currencies" icon={Banknote}>
                <DataTable value={this.state.currencies} loading={this.state.isLoading} defaultSortOrder={SortOrderType.Descending}>
                    <Column field="id" header="Id"></Column>
                    <Column field="name" header="Name"></Column>
                    <Column field="charCode" header="CharCode"></Column>
                    <Column
                        field="status"
                        header="Status"
                        body={(rowData: CurrencyModel) =>
                            StatusBadge(rowData.isActive, "Active", "Inactive")
                        }
                        filterMatchModeOptions={stringFilterMatchModeOptions}
                    ></Column>
                </DataTable>
            </PageLayout>
        );
    }
}
